/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Delivered
 *
 * 2 = Invoiced
 */
export enum SalesPerformanceReportType {
  Delivered = 1,
  Invoiced = 2,
}
